<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Raktárak</span>
      <el-button
        v-can="'storage.create'"
        style="float: right; margin-top: -5px;"
        type="success"
        size="small"
        icon="el-icon-plus"
        @click="$router.replace('/data/storages/add')"
      >
        Új raktár
      </el-button>
    </div>
    <div v-loading="loading" style="min-height: 81px;">
      <table-filter
        v-if="filterConfig"
        :config="filterConfig"
        action="storage/fetchAll"
      />
    </div>
    <storage-list style="min-height: 100px;" />
    <template v-if="$route.meta.showViewStorageDialog">
      <StorageViewDialog
        :storage-id="$route.params.id"
      />
    </template>
    <template v-if="$route.meta.showAddStorageDialog">
      <storage-dialog
        type="add"
      />
    </template>
    <template v-if="$route.meta.showUpdateStorageDialog">
      <storage-dialog
        :storageId="$route.params.id"
        type="update"
      />
    </template>
  </el-card>
</template>

<script>
import StorageList from '../../components/data/storages/List';
import StorageDialog from '../../components/data/storages/Dialog';
import TableFilter from '../../components/TableFilter';
import StorageViewDialog from '../../components/data/storages/View';

export default {
  components: {
    StorageList,
    StorageDialog,
    TableFilter,
    StorageViewDialog
  },
  data() {
    return {
      filterConfig: null,
      loading: false,
    };
  },
  async mounted() {
    this.loading = true;
    await this.setConfig();
    this.loading = false;
  },
  methods: {
    async setConfig() {
      let users = this.$store.getters['user/users'];
      let countries = this.$store.getters['country/countries'];
      let counties = this.$store.getters['county/counties'];
      let glaNumbers = this.$store.getters['glaNumber/glaNumbers'];
      if (!users.length) {
        await this.$store.dispatch('user/fetchAll');
        users = this.$store.getters['user/users'];
      }
      if(!countries.length) {
        await this.$store.dispatch('country/fetchAll');
        countries = this.$store.getters['country/countries'];
      }
      if(!counties.length) {
        await this.$store.dispatch('county/fetchAll');
        counties = this.$store.getters['county/counties'];
      }
      if (!glaNumbers.length) {
        await this.$store.dispatch('glaNumber/fetchAll');
        glaNumbers = this.$store.getters['glaNumber/glaNumbers'];
      }
      this.filterConfig = [
        {
          type: 'text',
          name: 'name',
          label: 'Név',
          defaultSearch: true,
        },
        {
          type: 'select',
          name: 'is_active',
          options: [
            {
              label: 'Aktív',
              status: 1,
            },
            {
              label: 'Inaktív',
              status: 0,
            },
          ],
          label: 'Státusz',
          labelCallback: status => status.label,
          valueKey: 'status',
        },
        {
          type: 'select',
          name: 'type',
          options: [
            {
              label: 'Képviselői',
              type: 'representative'
            },
            {
              label: 'Központi',
              type: 'own'
            },
          ],
          label: 'Típus',
          labelCallback: type => type.label,
          valueKey: 'type',
        },
        {
          type: 'select',
          options: users,
          name: 'user_id',
          label: 'Képviselő',
          labelCallback: user => user && `${user.last_name} ${user.first_name} (@${user.username})` || '',
          valueKey: 'id',
        },
        {
          type: 'select',
          options: users,
          name: 'deputy_user_id',
          label: 'Képviselő helyettes',
          labelCallback: user => user && `${user.last_name} ${user.first_name} (@${user.username})` || '',
          valueKey: 'id',
        },
        {
          type: 'select',
          name: 'country_id',
          options: countries,
          label: 'Ország',
          labelCallback: country => country && `${country.name}` || '',
          valueKey: 'id',
        },
        {
          type: 'select',
          name: 'county_id',
          options: counties,
          label: 'Megye',
          labelCallback: county => county && `${county.name}` || '',
          valueKey: 'id',
        },
        {
          type: 'text',
          name: 'postal_code',
          label: 'Irányítószám',
        },
        {
          type: 'text',
          name: 'city',
          label: 'Város',
        },
        {
          type: 'text',
          name: 'address',
          label: 'Cím',
        },
      ];
    },
  },
};
</script>
